window.klaroConfig = {
    elementID: 'klaro',
    htmlTexts: true,
    groupByPurpose: false,
    hideDeclineAll: true,
    privacyPolicy: {
        default: '/dataskydd/gdpr/',
        fi: '/tietosuoja/gdpr/',
        sv: '/dataskydd/gdpr/',
        en: '/data-policy/gdpr/',
    },
    translations: {
        sv: {
            privacyPolicy: {
                text: 'Här kan du läsa vår {privacyPolicy}-policy och hur vi använder cookies.',
                name: 'GDPR',
            },
            consentNotice: {
                learnMore: 'Anpassa inställningar',
                description: '<h2>Denna webbplats använder cookies</h2><p>Vår webbplats följer <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="dataskydd/gdpr/">GDPR</a> och använder <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="dataskydd/cookies/">cookies</a> för att förbättra användarupplevelsen.</p>',
            },
            consentModal: {
                title: 'Anpassa dina val',
                description: ' ',
            },
            acceptSelected: 'Spara',
            poweredBy: 'Powered by - KIProtect | Klaro',
            ok: 'Godkänn',
            purposes: {
                analytics: 'Analys',
                security: 'Säkerhet',
                statistics: 'Statistik',
                advertising: 'Marknadsföring',
            },
            googleAnalytics: {
                description: '',
            },
            googleTagManager: {
                description: '',
            },
            facebookPixel: {
                description: '',
            },
        },
        fi: {
            privacyPolicy: {
                text: 'Täältä voit lukea {privacyPolicy}-käytäntömme ja kuinka käytämme evästeitä.',
                name: 'GDPR',
            },
            consentNotice: {
                learnMore: 'Asetukset',
                description: '<h2>Tämä sivusto käyttää evästeitä</h2>Verkkosivustomme noudattaa <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="tietosuoja/gdpr/">GDPR</a>:ää ja käyttää <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="tietosuoja/cookies/">evästeitä</a> parantaakseen käyttäjäkokemusta.',
            },
            consentModal: {
                title: 'Muokkaa valintojasi',
                description: ' ',
            },
            acceptSelected: 'Tallenna',
            poweredBy: 'Powered by - KIProtect | Klaro',
            ok: 'Hyväksy',
            purposes: {
                analytics: 'Analyysi',
                security: 'Turvallisuus',
                statistics: 'Tilastot',
                advertising: 'Markkinointi',
            },
            googleAnalytics: {
                description: '',
            },
            googleTagManager: {
                description: '',
            },
            facebookPixel: {
                description: '',
            },
        },
        en: {
            privacyPolicy: {
                text: 'Here you can read our {privacyPolicy} policy and how we use cookies.',
                name: 'GDPR',
            },
            consentNotice: {
                learnMore: 'Customize',
                description: '<h2>This website uses cookies</h2>Our website follows the <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="tietosuoja/gdpr/">GDPR</a> regulation and uses <a class="text-light-green" style="border-bottom:1px solid #fff" target="_blank" href="tietosuoja/cookies/">cookies</a> to improve user experience.',
            },
            consentModal: {
                title: 'Customize your choices',
                description: ' ',
            },
            poweredBy: 'Powered by - KIProtect | Klaro',
            ok: 'Accept',
            purposes: {
                analytics: 'Analytics',
                security: 'Security',
                statistics: 'Statistics',
                advertising: 'Advertising',
            },
            googleAnalytics: {
                description: '',
            },
            googleTagManager: {
                description: '',
            },
            facebookPixel: {
                description: '',
            },
        },
    },
    services: [
        {
            name: 'googleAnalytics',
            title: 'Google Analytics',
            purposes: ['analytics', 'advertising'],
            default: true,
            cookies: [/^_ga.*$/, /^_gid.*$/],
            callback: function(consent, app) {
                if (typeof initGoogleAnalytics !== 'undefined') {
                    initGoogleAnalytics(consent);
                }
            },
            onAccept: `
                gtag('consent', 'update', {
                    'analytics_storage': 'granted',
                })
            `,
            onDecline: `
                gtag('consent', 'update', {
                    'analytics_storage': 'denied',
                })
            `,
        },
        {
            name: 'googleTagManager',
            title: 'Google Tag Manager',
            purposes: ['analytics', 'advertising'],
            default: true,
            cookies: [/^_gat_gtm.*$/, /^_gid.*$/],
            onAccept: `
                for(let k of Object.keys(opts.consents)){
                    if (opts.consents[k]){
                        let eventName = 'klaro-'+k+'-accepted'
                        dataLayer.push({'event': eventName})
                    }
                }
            `,
            onInit: `
                window.dataLayer = window.dataLayer || [];
                window.gtag = function(){dataLayer.push(arguments)}
                gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'})
                gtag('set', 'ads_data_redaction', true)
            `,
        },
        {
            name: 'facebookPixel',
            title: 'Facebook Pixel',
            purposes: ['advertising'],
            default: true,
            cookies: ['.facebook.com'],
            onAccept: `
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted'
                })
            `,
            onDecline: `
                gtag('consent', 'update', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied'
                })
            `,
        }
    ],
}
